import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import api from '../api';

const NotifContext = createContext(null);

// iPhone Safari ve uygulama ici tarayicilarda Notification API yok
function hasNotif() {
  try { return typeof window !== 'undefined' && 'Notification' in window && !!window.Notification; } catch (e) { return false; }
}

export function useNotifications() {
  return useContext(NotifContext) || { unreadCount: 0, setUnreadCount: () => {}, markAllRead: () => {}, fetchUnread: () => {} };
}

export function NotificationProvider({ children }) {
  const [unreadCount, setUnreadCount] = useState(0);
  const [toasts, setToasts] = useState([]);
  const wsRef = useRef(null);

  useEffect(() => {
    // Token yoksa hiçbir şey yapma (login sayfasında)
    if (!localStorage.getItem('token')) return;

    fetchUnread();
    connectWS();

    try {
      if (hasNotif() && window.Notification.permission === 'default') {
        const p = window.Notification.requestPermission();
        if (p && p.catch) p.catch(() => {});
      }
    } catch (e) {}

    return () => {
      if (wsRef.current) wsRef.current.close();
    };
  }, []);

  async function fetchUnread() {
    if (!localStorage.getItem('token')) return;
    try {
      const res = await api.get('/chat/unread-total');
      setUnreadCount(res.data.count);
    } catch(e) {}
  }

  function connectWS() {
    if (!localStorage.getItem('token')) return;

    const ws = new WebSocket((window.location.protocol === 'https:' ? 'wss' : 'ws') + '://' + window.location.host + '/ws');
    wsRef.current = ws;

    ws.onmessage = (e) => {
      try {
        const data = JSON.parse(e.data);
        if (data.event === 'new_message' && data.message.direction === 'in') {
          const msg = data.message;
          if (msg.content?.startsWith('/start')) return;

          setUnreadCount(prev => prev + 1);

          const id = Date.now();
          const toast = {
            id,
            name: msg.full_name || 'Kullanıcı',
            message: msg.type !== 'text' ? `📎 ${msg.type}` : (msg.content?.substring(0, 60) || ''),
            telegram_id: msg.telegram_id,
            bot_id: msg.bot_id,
            time: new Date().toLocaleTimeString('tr-TR', { hour:'2-digit', minute:'2-digit' }),
          };
          setToasts(prev => [toast, ...prev.slice(0, 3)]);
          setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 6000);

          if (hasNotif() && window.Notification.permission === 'granted') {
            const notif = new window.Notification(`💬 ${toast.name}`, {
              body: toast.message,
              icon: '/logo192.png',
              tag: `msg-${msg.telegram_id}`,
            });
            notif.onclick = () => { window.focus(); };
          }
        }
      } catch(e) {}
    };

    ws.onclose = () => {
      // Sadece token varsa yeniden bağlan
      if (localStorage.getItem('token')) {
        setTimeout(connectWS, 3000);
      }
    };
  }

  function dismissToast(id) {
    setToasts(prev => prev.filter(t => t.id !== id));
  }

  function markAllRead() { setUnreadCount(0); }

  return (
    <NotifContext.Provider value={{ unreadCount, setUnreadCount, markAllRead, fetchUnread }}>
      {children}

      <div style={{
        position: 'fixed', top: 16, right: 16, zIndex: 99999,
        display: 'flex', flexDirection: 'column', gap: 8,
        pointerEvents: 'none',
      }}>
        {toasts.map(toast => (
          <div key={toast.id} style={{
            background: '#1a2740',
            border: '1px solid rgba(59,130,246,0.35)',
            borderLeft: '4px solid #3b82f6',
            borderRadius: 12,
            padding: '12px 16px',
            width: 320,
            boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
            display: 'flex', alignItems: 'flex-start', gap: 10,
            pointerEvents: 'all',
            cursor: 'pointer',
            animation: 'slideInRight 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
          }} onClick={() => {
            dismissToast(toast.id);
            window.location.href = '/chat';
          }}>
            <div style={{
              width: 38, height: 38, borderRadius: '50%', flexShrink: 0,
              background: `linear-gradient(135deg, hsl(${toast.telegram_id % 360}, 60%, 35%), hsl(${(toast.telegram_id % 360)+60}, 60%, 25%))`,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 16, fontWeight: 700, color: 'white',
            }}>
              {toast.name[0]?.toUpperCase()}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 3 }}>
                <span style={{ fontSize: 13, fontWeight: 700, color: '#e2e8f0' }}>{toast.name}</span>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <span style={{ fontSize: 11, color: '#64748b' }}>{toast.time}</span>
                  <button onClick={e => { e.stopPropagation(); dismissToast(toast.id); }}
                    style={{ background: 'none', border: 'none', color: '#64748b', cursor: 'pointer', fontSize: 14, padding: 0, lineHeight: 1 }}>✕</button>
                </div>
              </div>
              <div style={{ fontSize: 12, color: '#94a3b8', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {toast.message}
              </div>
              <div style={{ fontSize: 11, color: '#3b82f6', marginTop: 4 }}>Cevaplamak için tıkla →</div>
            </div>
          </div>
        ))}
      </div>

      <style>{`
        @keyframes slideInRight {
          from { transform: translateX(120%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `}</style>
    </NotifContext.Provider>
  );
}
